export const ACCESS_FILES = [ 'png', 'jpg', 'jpeg', 'gif' ];
export const START_WEEK_TYPES = [
	{
		value: "PickUp",
		id: 1,
	},
	{
		value: "Delivery",
		id: 2,
	},
];
export const START_WEEKS = [
	{
		value: "Monday",
		id: 1,
	},
	{
		value: "Tuesday",
		id: 2,
	},
	{
		value: "Wednesday",
		id: 3,
	},
	{
		value: "Thursday",
		id: 4,
	},
	{
		value: "Friday",
		id: 5,
	},
	{
		value: "Saturday",
		id: 6,
	},
	{
		value: "Sunday",
		id: 7,
	},
];
